let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bgQev")).then(() => parcelRequire('5abEo'));